import { Link } from 'react-router-dom'

/**
 * Onglets en haut d'une section (CRM, Compte…) : un lien par sous-page.
 * @param {{key: string, to: string, label: string, icon?: any, badge?: string}[]} tabs
 */
export default function SectionTabs({ tabs, activeKey, label }) {
  return (
    // relative z-10 : certaines pages (Candidats FT, Projets auto) ont un fond qui déborde vers le haut.
    <nav className="relative z-10 mb-6 flex flex-wrap gap-2" aria-label={label}>
      {tabs.map((tab) => {
        const Icon = tab.icon
        const active = tab.key === activeKey
        return (
          <Link
            key={tab.key}
            to={tab.to}
            aria-current={active ? 'page' : undefined}
            className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition ${
              active
                ? 'bg-[#5b5cf4] text-white'
                : 'border border-white/10 text-white/60 hover:border-white/20 hover:text-white'
            }`}
          >
            {Icon && <Icon className="h-4 w-4" />}
            {tab.label}
            {tab.badge && (
              <span className={`rounded-full px-1.5 py-0.5 text-[10px] font-bold ${active ? 'bg-black/15' : 'bg-white/10 text-white/50'}`}>
                {tab.badge}
              </span>
            )}
          </Link>
        )
      })}
    </nav>
  )
}
